import { Board } from '~/components/Shared/Layout/Board/Board';
import { UserPromotionFormTable } from './UserPromotionFormTable/UserPromotionFormTable';
import styles from './UserPromotionFormBoard.module.scss';
import { DatePicker } from 'antd';
import { useTranslation } from 'react-i18next';
import dayjs, { Dayjs } from 'dayjs';
import { Spinner } from '~/ui';

interface IUserPromotionProps {
  dates: [Dayjs | null, Dayjs | null] | null;
  data: {
    points: number;
    created_at: string;
    promo_loyalty: { name: string };
    manual_action: boolean | null;
    by_user: {
      full_name: string;
      id: number;
    };
  }[];
  setDates: (dates: [Dayjs | null, Dayjs | null] | null) => void;
  isLoading: boolean;
  sort: { field: string; direction: string };
  setSort: ({ field, direction }: { field: string; direction: string }) => void;
}

export const UserPromotionFormBoard = ({
  data,
  isLoading,
  dates,
  setDates,
  sort,
  setSort,
}: IUserPromotionProps) => {
  const { t } = useTranslation();

  return (
    <Board classNames={styles.board}>
      <div className={styles.dateWrapper}>
        <DatePicker.RangePicker
          disabled={isLoading || data?.length === 0}
          placeholder={[t('date_validate'), t('date_validate')]}
          className={styles.datePicker}
          value={dates}
          onChange={date => setDates(date ? [date[0], date[1]] : null)}
          format="DD.MM.YYYY"
          disabledDate={current => current && current.isAfter(dayjs(), 'day')}
        />
      </div>
      {data && !isLoading ? (
        <UserPromotionFormTable data={data} sort={sort} setSort={setSort} />
      ) : (
        <Spinner />
      )}
    </Board>
  );
};
